import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderRecipeCards2 from "../../../../src/content/graham-recipe-cards-2nd-edition/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderRecipeCards2,
  React
};